const carRental = {
  carRental: "Thuê xe hơi", // translated 
  carRentals: "Thuê xe hơi", // translated 
  pickUpPoint: "Điểm đón", // translated 
  dropOffPoint: "Điểm trả khách", // translated 
  pleaseSelectAPickUpPoint: "Vui lòng chọn điểm đón.", // translated 
  pickUpDate: "Ngày nhận hàng", // translated 
  dropOffDate: "Ngày giao hàng", // translated 
  pickUp: "Nhặt lên", // translated 
  dropOff: "Điểm trả khách", // translated 
  edit: "Biên tập", // translated 
  fuelPolicy: "Chính sách nhiên liệu", // translated 
  pickUpLocation: "Địa điểm đón khách", // translated 
  mileage: "Số dặm", // translated 
  transmission: "Quá trình lây truyền", // translated 
  airCondition: "Máy điều hòa không khí", // translated 
  minimumAge: "Độ tuổi tối thiểu", // translated 
  maximumAge: "Tuổi tối đa", // translated 
  providerAddress: "Địa chỉ nhà cung cấp", // translated 
  providerPhone: "Số điện thoại nhà cung cấp", // translated 
  driverInfo: "Thông tin tài xế", // translated 
  driversInfo: "Thông tin tài xế", // translated 
  differentDropOff: "Trả khách tại địa điểm khác", // translated 
  maxPassengers: "Số hành khách tối đa", // translated 
  budget: "Ngân sách", // translated 
  provider: "Nhà cung cấp", // translated 
  carModel: "Mô hình xe hơi", // translated 
  numOfDoors: "Số lượng cửa", // translated 
  fuelType: "Loại nhiên liệu", // translated 
  driverAge: "Tuổi của người lái xe", // translated 
  enterValidDriversAge: "Vui lòng nhập tuổi hợp lệ của người lái xe.", // translated 
  workingHours: "Giờ làm việc", // translated 
  driverNationality: "Quốc tịch của tài xế", // translated 
  nationalityIsRequired: "Cần có giấy tờ chứng minh quốc tịch.", // translated 
  carRentalRate: "Giá thuê xe hơi", // translated 
  dueNow: "Đến hạn ngay", // translated 
  duePickUp: "Thanh toán khi nhận hàng", // translated 
  toViewOfferPDF:
    "Để xem tài liệu PDF chứa tất cả các điều khoản cho thuê của ưu đãi này, vui lòng", // translated 
  toViewTermsAndCondPDF:
    "Để xem các Điều khoản và Điều kiện CARNECT hiện hành, vui lòng", // translated 
  carRentalsNotFound:
    "Chúng tôi không tìm thấy kết quả cho thuê xe nào. Xin lỗi vì sự bất tiện này.", // translated 
};


export default carRental;
